import { Rating } from 'aurorui'
import {Helmet} from 'react-helmet';
import { useState } from 'react';
import './style.css';
import React from 'react'
import { ComponentScreen } from '../component-screen';
import { PropsTable } from '../../components';

function RatingScreen() {
    const [modalVisible, setModalVisible] = useState(true);
  return (
   <div className=' screen red-bg'>
    <Helmet>
        <meta charSet="utf-8" />
        <title>Rating</title>
    </Helmet>
      <h1 className="component-name">Rating</h1>
    
      <div className='display-wrapper'>
            <div className='display_grid_rating'>
                <h2 className='rate-my'>Rate my component</h2>
                <div>
                    <Rating 
                        totalRating={7}
                        ratingAlloted={3}
                        onRatingChange={()=>{}}
                    />
                </div>
            </div>
      </div>
     

      <div className='props-sec'>
        <h3 className='props-header'>Props</h3>
        <PropsTable props={props}/>
      </div>
      
    </div>
  )
}

const props = [
  {
    name: "totalRating",
    required: 'true',
    description: "max rating possible",
    possible_values: "number"
  },
  {
    name: "ratingAlloted",
    required: 'true',
    description: "rating given out of totalRating",
    possible_values: "number"
  },
  {
    name: "onRatingChange",
    required: 'true',
    description: "function to be launched on rating change.",
    possible_values: "boolean"
  },
  
]

export default ComponentScreen(RatingScreen)